import React from 'react';

import AuthUserContext from '../context/session/context';
import withFirebase from './withFirebase';

// Decorador para poder exponer al arbol la sesion. Incluye un listener para cuando se cierra o abre sesion.
// Incluye auth user
const withAuthentication = (Component) => {
  class WithAuthentication extends React.Component {
    constructor(props) {
      super(props);

      const initUser = JSON.parse(localStorage.getItem('authUser'));
      if (initUser && initUser.birthday) {
        const { seconds, nanoseconds } = initUser.birthday;
        initUser.birthday = new this.props.firebase.firestore.Timestamp(
          seconds,
          nanoseconds
        );
      }

      this.state = {
        authUser: initUser,
      };
    }

    componentDidMount() {
      this.listener = this.props.firebase.onAuthUserListener(
        (authUser) => {
          localStorage.setItem('authUser', JSON.stringify(authUser));
          this.setState({ authUser });
        },
        () => {
          localStorage.removeItem('authUser');
          this.setState({ authUser: null });
        }
      );
    }

    componentWillUnmount() {
      this.listener();
    }

    render() {
      return (
        <AuthUserContext.Provider value={this.state.authUser}>
          <Component {...this.props} />
        </AuthUserContext.Provider>
      );
    }
  }

  return withFirebase(WithAuthentication);
};

export default withAuthentication;
